/* ============================================================
   Initialize Carousel
   ============================================================ */
function initRelatedCarousel() {
  const carousels = document.querySelectorAll("[data-related-carousel]");
  if (!carousels.length) return;

  carousels.forEach((carousel) => {

    /* --------------------------------------------------------
       Avoid early initialization — wait until items exist
       -------------------------------------------------------- */
    const items = carousel.querySelectorAll(".carousel-list > li");
    if (!items.length) {
      console.log("No items yet — delaying initialization");
      return;
    }

    if (carousel.dataset.initialized === "true") return;

    const track = carousel.querySelector(".carousel-track");
    const list = carousel.querySelector(".carousel-list");
    const btnPrev = carousel.querySelector(".carousel-arrow.prev");
    const btnNext = carousel.querySelector(".carousel-arrow.next");

    if (!track || !list || !btnPrev || !btnNext) return;

    console.log("Carousel initialized");
    carousel.dataset.initialized = "true";

    let gap = parseInt(getComputedStyle(list).gap) || 24;

    /* ------------------------------
       Always measure width dynamically
       ------------------------------ */
    function getCardWidth() {
      const firstCard = list.querySelector("li");
      return firstCard ? firstCard.getBoundingClientRect().width : 0;
    }

    /* ------------------------------
       Arrow Enable / Disable
       ------------------------------ */
    function updateArrows() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const x = track.scrollLeft;

      btnPrev.classList.toggle("disabled", x <= 0);
      btnNext.classList.toggle("disabled", x >= maxScroll - 5);
    }

    /* ------------------------------
       Arrow Button Handlers
       ------------------------------ */
    btnPrev.addEventListener("click", () => {
      const w = getCardWidth();
      track.scrollBy({
        left: -(w + gap),
        behavior: "smooth"
      });
    });

    btnNext.addEventListener("click", () => {
      const w = getCardWidth();
      track.scrollBy({
        left: w + gap,
        behavior: "smooth"
      });
    });

    track.addEventListener("scroll", updateArrows);

    /* ------------------------------
       Drag-to-Scroll (Mouse + Touch)
       ------------------------------ */
    let isDown = false;
    let startX;
    let scrollStart;

    track.addEventListener("mousedown", (e) => {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollStart = track.scrollLeft;
      track.classList.add("dragging");
    });

    track.addEventListener("mouseleave", () => {
      isDown = false;
      track.classList.remove("dragging");
    });

    track.addEventListener("mouseup", () => {
      isDown = false;
      track.classList.remove("dragging");
    });

    track.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX);
      track.scrollLeft = scrollStart - walk;
    });

    /* Touch Support */
    track.addEventListener("touchstart", (e) => {
      startX = e.touches[0].pageX - track.offsetLeft;
      scrollStart = track.scrollLeft;
    });

    track.addEventListener("touchmove", (e) => {
      const x = e.touches[0].pageX - track.offsetLeft;
      const walk = (x - startX) * 1.2;
      track.scrollLeft = scrollStart - walk;
    });

    /* ------------------------------
       Re-enable arrows on resize
       ------------------------------ */
    window.addEventListener("resize", updateArrows);

    requestAnimationFrame(updateArrows);
  });
}

/* ============================================================
   MutationObserver — waits for final product cards, not early
   DOM mutations from Shopify.
   ============================================================ */
function observeRecommendations() {
  const observer = new MutationObserver(() => {
    const carousels = document.querySelectorAll("[data-related-carousel]");
    carousels.forEach((carousel) => {

      const hasItems = carousel.querySelectorAll(".carousel-list > li").length > 0;

      if (hasItems) {
        console.log("Carousel detected with items → initializing");
        initRelatedCarousel();
      } else {
        console.log("Carousel found but empty → waiting...");
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}


/* ============================================================
   Initialize on load
   ============================================================ */
window.addEventListener("DOMContentLoaded", () => {
  initRelatedCarousel();
  observeRecommendations();
});
